(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pz-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pz-runtime')) {
 customElements.define('pz-runtime', class extends HTMLElement {
  connectedCallback() {
   if (this.initialized || typeof HTMLDialogElement === 'undefined') return;
   this.initialized = true;
   this.busy = false;
   this.wishes = this.readWishes();
   this.abort = new AbortController();
   const opts = { signal: this.abort.signal };
   document.documentElement.classList.add('pz-enhanced');
   document.addEventListener('click', event => this.click(event), opts);
   document.addEventListener('submit', event => this.submit(event), opts);
   document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.pz-menu[open],.pz-desktop-menu details[open]').forEach(menu => menu.open = false);
   }, opts);
   document.addEventListener('shopify:section:load', () => this.syncButtons(), opts);
   window.addEventListener('storage', event => { if (event.key === 'pz-wishlist-v1') { this.wishes = this.readWishes(); this.syncButtons(); this.renderWishes(); } }, opts);
   this.querySelectorAll('dialog').forEach(dialog => dialog.addEventListener('close', () => {
    if (!this.querySelector('dialog[open]')) document.documentElement.classList.remove('pz-dialog-open');
   }, opts));
   this.syncButtons();
   const attachRideCart = () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
     this.unsubscribeRideCart = subscribe(PUB_SUB_EVENTS.cartUpdate, () => { if (!this.busy) this.refreshCart(); });
    }
   };
   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', attachRideCart, { once: true, signal: this.abort.signal });
   else attachRideCart();
  }
  disconnectedCallback() { this.unsubscribeRideCart?.(); this.abort?.abort(); this.initialized = false; document.documentElement.classList.remove('pz-dialog-open'); }
  safeUrl(value, image = false) {
   if (!value || typeof value !== 'string') return '';
   try {
    const url = new URL(value, location.origin);
    if (!['http:', 'https:'].includes(url.protocol)) return '';
    if (url.origin === location.origin) return url.href;
    if (image && url.protocol === 'https:' && url.hostname === 'cdn.shopify.com') return url.href;
   } catch (_) { /* Invalid stored URLs are discarded. */ }
   return '';
  }
  readWishes() {
   try {
    const data = JSON.parse(localStorage.getItem('pz-wishlist-v1') || '[]');
    if (!Array.isArray(data)) return [];
    return data.filter(item => item && /^\d+$/.test(item.id) && typeof item.title === 'string' && typeof item.url === 'string' && this.safeUrl(item.url)).slice(0, 100).map(item => ({ id: String(item.id), title: item.title.slice(0, 300), url: this.safeUrl(item.url), image: typeof item.image === 'string' ? this.safeUrl(item.image, true) : '' }));
   } catch (_) { return []; }
  }
  syncButtons() {
   document.querySelectorAll('[data-pz-save]').forEach(button => button.setAttribute('aria-pressed', String(this.wishes.some(item => item.id === button.dataset.id))));
   document.querySelectorAll('.pz-bottom-nav a').forEach(link => {
    if (new URL(link.href).pathname === location.pathname) link.setAttribute('aria-current', 'page');
    else link.removeAttribute('aria-current');
   });
  }
  persistWishes() {
   try { localStorage.setItem('pz-wishlist-v1', JSON.stringify(this.wishes)); }
   catch (_) { this.open('wishlist'); const status = this.querySelector('[data-pz-wishlist-status]'); if (status) status.textContent = this.dataset.storageError; }
   this.syncButtons(); this.renderWishes();
  }
  renderWishes() {
   const mount = this.querySelector('[data-pz-wishlist-mount]');
   if (!mount) return;
   mount.replaceChildren();
   if (!this.wishes.length) { const p = document.createElement('p'); p.className = 'pz-empty'; p.textContent = this.dataset.empty; mount.append(p); }
   this.wishes.forEach(item => {
    const row = document.createElement('div'); row.className = 'pz-wish-item';
    if (item.image) { const img = document.createElement('img'); img.src = item.image; img.alt = ''; img.width = 64; img.height = 80; row.append(img); }
    const link = document.createElement('a'); link.href = item.url; link.textContent = item.title;
    const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.pzUnsave = item.id; remove.textContent = this.dataset.remove; remove.setAttribute('aria-label', this.dataset.remove + ' — ' + item.title);
    row.append(link, remove); mount.append(row);
   });
  }
  open(name) {
   const dialog = this.querySelector('#PzDialog-' + name);
   if (!dialog) return false;
   this.querySelectorAll('dialog[open]').forEach(other => { if (other !== dialog) other.close(); });
   if (!dialog.open) dialog.showModal();
   document.documentElement.classList.add('pz-dialog-open');
   return true;
  }
  click(event) {
   if (!(event.target instanceof Element)) return;
   const target = event.target;
   const close = target.closest('[data-pz-close]');
   if (close) { close.closest('dialog')?.close(); return; }
   const opener = target.closest('[data-pz-open]');
   if (opener) {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (this.open(opener.dataset.pzOpen)) {
     event.preventDefault();
     if (opener.dataset.pzOpen === 'wishlist') this.renderWishes();
     if (opener.dataset.pzOpen === 'cart' && !this.busy) this.refreshCart();
    }
    return;
   }
   const save = target.closest('[data-pz-save]');
   if (save) {
    const { id, title, url, image } = save.dataset;
    if (this.wishes.some(item => item.id === id)) this.wishes = this.wishes.filter(item => item.id !== id);
    else if (this.safeUrl(url)) this.wishes = [...this.wishes, { id, title, url: this.safeUrl(url), image: this.safeUrl(image || '', true) }].slice(-100);
    this.persistWishes(); return;
   }
   const unsave = target.closest('[data-pz-unsave]');
   if (unsave) { this.wishes = this.wishes.filter(item => item.id !== unsave.dataset.pzUnsave); this.persistWishes(); this.querySelector('[data-pz-unsave],#PzDialog-wishlist [data-pz-close]')?.focus(); return; }
   const quick = target.closest('[data-pz-quick]');
   if (quick) { const template = document.getElementById(quick.dataset.pzQuick); if (template instanceof HTMLTemplateElement) { this.querySelector('[data-pz-quick-mount]').replaceChildren(template.content.cloneNode(true)); this.open('quick'); } return; }
   const expand = target.closest('[data-pz-expand]');
   if (expand) { const section = document.getElementById(expand.dataset.pzExpand); if (section) { const expanded = section.dataset.expanded !== 'true'; section.dataset.expanded = String(expanded); expand.setAttribute('aria-expanded', String(expanded)); expand.textContent = expanded ? this.dataset.less : this.dataset.all; } return; }
   const change = target.closest('[data-pz-change]');
   if (change) { this.changeCart(change); return; }
   const menuLink = target.closest('.pz-menu a,.pz-desktop-menu details a');
   if (menuLink) menuLink.closest('details').open = false;
   const anchor = target.closest('.pz-scope a[href*="#"]');
   if (anchor && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey) {
    const url = new URL(anchor.href);
    if (url.origin === location.origin && url.pathname === location.pathname && url.search === location.search && url.hash) {
     let id; try { id = decodeURIComponent(url.hash.slice(1)); } catch (_) { return; }
     const section = document.getElementById(id);
     if (section) { event.preventDefault(); section.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth', block: 'start' }); history.replaceState(null, '', url.hash); }
    }
   }
  }
  setBusy(value) {
   this.busy = value;
   document.querySelectorAll('.pz-add-form button[type="submit"],[data-pz-change]').forEach(button => button.disabled = value);
   this.querySelector('[data-pz-cart-mount]').setAttribute('aria-busy', String(value));
  }
  async request(url, options = {}) {
   const controller = new AbortController();
   const timer = setTimeout(() => controller.abort(), 15000);
   try {
    const response = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
    if (!response.ok) { let message = ''; try { const data = await response.json(); message = typeof data.description === 'string' ? data.description : ''; } catch (_) { /* Use localized fallback. */ } const failure = new Error(message || this.dataset.error); failure.pzServer = true; throw failure; }
    return options.text ? await response.text() : await response.json();
   } catch (error) { throw error.pzServer ? error : new Error(this.dataset.error); } finally { clearTimeout(timer); }
  }
  mountCart(html) {
   if (typeof html !== 'string') throw new Error(this.dataset.refreshError);
   const parsed = new DOMParser().parseFromString(html, 'text/html');
   const content = parsed.querySelector('[data-pz-cart-content]');
   if (!content) throw new Error(this.dataset.refreshError);
   this.querySelector('[data-pz-cart-mount]').replaceChildren(document.importNode(content, true));
   const count = String(Math.max(0, Number(content.dataset.count) || 0));
   document.querySelectorAll('[data-pz-cart-count]').forEach(badge => badge.textContent = count);
  }
  async fetchCart() {
   const url = new URL(this.dataset.cart, location.origin);
   url.searchParams.set('section_id', 'pz-cart-content');
   url.searchParams.set('_pz', String(Date.now()));
   this.mountCart(await this.request(url.href, { text: true, cache: 'no-store' }));
  }
  async refreshCart() {
   if (this.busy) return;
   this.setBusy(true);
   const status = this.querySelector('[data-pz-cart-status]'); status.textContent = '';
   try { await this.fetchCart(); } catch (_) { status.textContent = this.dataset.refreshError; }
   finally { this.setBusy(false); }
  }
  async applyResponse(data) {
   if (data.sections?.['pz-cart-content']) this.mountCart(data.sections['pz-cart-content']);
   else await this.fetchCart();
  }
  async submit(event) {
   const form = event.target;
   if (!(form instanceof HTMLFormElement) || !form.matches('.pz-add-form')) return;
   event.preventDefault(); if (this.busy) return;
   this.setBusy(true);
   const status = form.querySelector('.pz-form-status'); status.textContent = '';
   let added = false;
   try {
    const body = new FormData(form); body.set('sections', 'pz-cart-content'); body.set('sections_url', this.dataset.root);
    const data = await this.request(this.dataset.add, { method: 'POST', body, headers: { Accept: 'application/json' } });
    added = true; status.textContent = this.dataset.added;
    this.querySelector('[data-pz-cart-status]').textContent = this.dataset.added;
    this.open('cart'); await this.applyResponse(data);
   } catch (error) {
    const message = added ? this.dataset.refreshError : error.message || this.dataset.error;
    status.textContent = message;
    this.querySelector('[data-pz-cart-status]').textContent = message;
    if (added) this.open('cart');
   } finally { this.setBusy(false); }
  }
  async changeCart(button) {
   if (this.busy) return;
   const quantity = Number(button.dataset.pzChange);
   if (!Number.isInteger(quantity) || quantity < 0) return;
   const key = button.dataset.key;
   const focusAction = button.dataset.pzAction;
   this.setBusy(true);
   const status = this.querySelector('[data-pz-cart-status]'); status.textContent = '';
   let changed = false;
   try {
    const data = await this.request(this.dataset.change, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: ['pz-cart-content'], sections_url: this.dataset.root }) });
    changed = true; await this.applyResponse(data);
   } catch (error) { status.textContent = changed ? this.dataset.refreshError : error.message || this.dataset.error; }
   finally {
    this.setBusy(false);
    const line = [...this.querySelectorAll('[data-pz-line]')].find(item => item.dataset.pzLine === key);
    const control = line && [...line.querySelectorAll('[data-pz-change]')].find(item => item.dataset.pzAction === focusAction);
    (control || this.querySelector('#PzDialog-cart [data-pz-close]')).focus();
   }
  }
 });
}
  } catch(e) { console.error(e); }
})();

})();
